import { useEffect, useState } from "react";
import Alfamart from "./Alfamart";
import Notfound from "../../Notfound";
import Mandiri from "./Mandiri";
import Bri from "./Bri";
import Bni from "./Bni";
import Bsi from "./Bsi";
import Bjb from "./Bjb";
import Cimb from "./Cimb";
import Permata from "./Permata";
import BriLink from "./Brilink";
import Indomaret from "./Indomaret";


const Xenplatform = ({channel, invoice_id, user_id}) => {
    const [views, setViews] = useState("");

    const getViewChannel = (channel, invoice_id, user_id) => {
        switch(channel) {
            case 'ALFAMART' :
                setViews(<Alfamart invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'INDOMARET' :
                setViews(<Indomaret invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'MANDIRI' :
                setViews(<Mandiri invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BRI' :
                setViews(<Bri invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BNI' :
                setViews(<Bni invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BSI' :
                setViews(<Bsi invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BJB' :
                setViews(<Bjb invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'CIMB' :
                setViews(<Cimb invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'PERMATA' :
                setViews(<Permata invoice_id={invoice_id} user_id={user_id}/>)
                break;
            case 'BRILINK' :
                setViews(<BriLink invoice_id={invoice_id} user_id={user_id}/>)
                break;
            default :
                setViews(<Notfound />)
                break;
        }
    }

    useEffect(() => {
        const init = () => {
            getViewChannel(channel, invoice_id, user_id)
        };
        init();
    }, [invoice_id, user_id, channel])
    
    return (
        <>{views}</>
    )
}

export default Xenplatform;